<div class="space-y-1">
  <!-- Input wrapper -->
  <div class="relative">
    <!-- Left icon -->
    @if (iconLeft) {
    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none z-10">
      <ng-content select="[slot=icon-left]"></ng-content>
    </div>
    }

    <input [id]="inputId" [class]="getComputedClasses()"
      [style.padding-left]="iconLeft ? '2.5rem' : '1rem'"
      [style.padding-right]="iconRight || clearable ? '2.5rem' : '1rem'"
      [style.padding-top]="'0.75rem'" [style.padding-bottom]="'0.75rem'" [type]="type"
      [placeholder]="placeholder || label" [disabled]="disabled" [readonly]="readonly" [value]="value"
      [required]="required" [attr.aria-label]="label || placeholder" [attr.maxlength]="maxLength"
      [attr.minlength]="minLength" [pattern]="pattern" [autocomplete]="autocomplete" (input)="onInput($event)"
      (blur)="onBlur()" (focus)="onFocus($event)" />

    <!-- Clear button -->
    @if (clearable && value && !disabled) {
    <button type="button"
      class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
      (click)="clearInput()">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>
    }

    <!-- Right icon -->
    @if (iconRight && !clearable) {
    <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
      <ng-content select="[slot=icon-right]"></ng-content>
    </div>
    }
  </div>

  <!-- Help text/Hint with character counter -->
  <div class="flex justify-between items-start">
    @if (showHint()) {
    <p class="text-sm text-gray-500 dark:text-gray-400 flex-1">
      {{ hint || helpText }}
    </p>
    } @if (showCounter && maxLength) {
    <span class="text-sm text-gray-400 dark:text-gray-500 ml-2"> {{ characterCount() }}/{{ maxLength }} </span>
    }
  </div>

  <!-- Error message -->
  @if (errorMessage) {
  <div class="flex justify-between items-start">
    <p class="text-sm text-red-600 dark:text-red-400 flex items-center flex-1">
      <svg class="w-4 h-4 mr-1 shrink-0" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd"
          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
          clip-rule="evenodd" />
      </svg>
      {{ errorMessage }}
    </p>
    @if (showCounter && maxLength) {
    <span class="text-sm text-red-400 ml-2"> {{ characterCount() }}/{{ maxLength }} </span>
    }
  </div>
  }

  <!-- Success message -->
  @if (successMessage) {
  <p class="text-sm text-cyan-600 dark:text-cyan-400 flex items-center">
    <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
      <path fill-rule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
        clip-rule="evenodd" />
    </svg>
    {{ successMessage }}
  </p>
  }
</div>
